export const PaymentType = Object.freeze({
  KEKS10: 'KEKS10',
  TELEGRAM20: 'TELEGRAM20',
  FREE: 'FREE',
  CASH20: 'CASH20',
  CARD20: 'CARD20',
  CASH50: 'CASH50',
  CARD50: 'CARD50',
})
